import Vue from 'vue/dist/vue.esm'
import VueProgressBar from 'vue-progressbar'
import newsListConfig from '@/scripts/components/news-list'
import elearningsListConfig from '@/scripts/components/elearnings-list'
import eventsRecordsListConfig from '@/scripts/components/events-records-list'
import invitationsListConfig from '@/scripts/components/invitations-list'
import storiesListConfig from '@/scripts/components/stories-list'
import actionsListConfig from '@/scripts/components/actions-list'
import faqListConfig from '@/scripts/components/faq-list'
import actionsDocumentsConfig from '@/scripts/components/action-documents'

Vue.use(VueProgressBar, {
  color: 'white',
  thickness: '4px',
})

const newsList = document.querySelector('#newsList')
if (newsList) {
  new Vue({
    el: '#newsList',
    ...newsListConfig
  })
}

const elearningsList = document.querySelector('#elearningsList');
if (elearningsList) {
    new Vue({
        el: '#elearningsList',
        ...elearningsListConfig
    })  
}

const eventsRecordsList = document.querySelector('#eventsRecordsList');
if (eventsRecordsList) {
    new Vue({
        el: '#eventsRecordsList',
        ...eventsRecordsListConfig
    })  
}

const invitationList = document.querySelector('#invitationList');
if (invitationList) {
  new Vue({
    el: '#invitationList',
    ...invitationsListConfig
  })
}

const storiesList = document.querySelector('#storiesList');
if (storiesList) {
  new Vue({
    el: '#storiesList',
    ...storiesListConfig
  })
}

const actionsList = document.querySelector('#actionsCalendar');
if (actionsList) {
  new Vue({
    el: '#actionsCalendar',
    ...actionsListConfig
  })
}

const faqList = document.querySelector('#faqList');
if (faqList) {
  new Vue({
    el: '#faqList',
    ...faqListConfig
  })
}

const documentsList = document.querySelector('#documentsList');
if (documentsList) {
  new Vue({
    el: '#documentsList',
    ...actionsDocumentsConfig
  })
}